<template>
  <div>
      <div :class="{collapsed: collapsed, sidebar: !$route.meta.hide_sidebar}">
        <sidebar-menu @item-click="item_click" :menu="menu" @toggle-collapse="onToggleCollapse" width="250px" :disableHover="true" v-if="!$route.meta.hide_sidebar" id="sidebar-menu">
          <i class="fa fa-chevron-right" slot="dropdown-icon"></i>
          <i class="fa fa-arrows-h" slot="toggle-icon"></i>

          <div slot="header"><b-link :to="{name: 'sites'}"><h2 class="site-logo text-white p-3">{{collapsed ? "K" : "Kaizen"}}</h2></b-link></div>
          <div slot="footer" v-if="!collapsed">
            <div class="notice text-center" v-if="trial_days_left !== undefined">
              <span v-if="trial_days_left > 0">{{trial_days_left}} day{{trial_days_left != 1 ? 's' : ''}} left of your trial</span>
              <span v-else>Your trial is over. Uprade to publish your site.</span>
              <b-button class="mt-2" block :to="{name: 'billing'}">Upgrade</b-button>
            </div>

          </div>
        </sidebar-menu>
        <Loading v-if="site === undefined"/>
        <Error v-else-if="site === null" code="404"></Error>
        <div v-else>
          <!-- TODO api key -->
          <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.title_font.replace(/'/g, '')" hidden></FontPicker>
          <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.body_font.replace(/'/g, '')" hidden></FontPicker>
          <router-view  :profile="profile" :user="user" :site="site"/>
        </div>
      </div>
  </div>
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
import { db } from '@/main.js'
import moment from 'moment'

import FontPicker from 'font-picker-vue'

export default {
  name: 'site_container',
  props: ['profile', 'user'],
  components: {FontPicker},
  data () {
    return {
      collapsed: false,
      site: undefined,
      menu: [
        {href: {name: 'site'}, title: 'Dashboard', icon: 'fad fa-tachometer-alt'},
        {href: '#', external: true, title: 'View', icon: 'fad fa-external-link-square-alt'},

        {header: true, title: 'Website', hiddenOnCollapse: true},
        {href: {name: 'singles'}, title: 'Pages', icon: 'fad fa-file-alt'},
        {href: {name: 'blogs'}, title: 'Blog', icon: 'fad fa-newspaper'},
        {href: {name: 'services'}, title: 'Services', icon: 'fad fa-concierge-bell'},
        {href: {name: 'awards'}, title: 'Awards', icon: 'fad fa-trophy'},
        {href: {name: 'testimonials'}, title: 'Testimonials', icon: 'fad fa-chalkboard-teacher'},
        {href: {name: 'forms'}, title: 'Forms', icon: 'fad fa-keyboard'},

        {header: true, title: 'Measure', hiddenOnCollapse: true},
        {href: {name: 'site_analytics'}, title: 'Analytics', icon: 'fad fa-chart-area'},

        {header: true, title: 'Grow', hiddenOnCollapse: true},
        {href: {name: 'content_auto'}, title: 'Content', icon: 'fad fa-pen', alias: '/site/:site_id/content/:sub_dir'},
        {href: {name: 'locations'}, title: 'Directories', icon: 'fad fa-link', alias: '/site/:site_id/links/:sub_dir'},
        // {href: {name: 'social_accounts'}, title: 'Social', icon: 'fas fa-thumbs-up'},
        {header: true, title: 'Settings', hiddenOnCollapse: true},
        {href: {name: 'site_edit'}, title: 'Account', icon: 'fad fa-cog', alias: '/site/:site_id/settings/:sub_dir'},
        {href: {name: 'domains'}, title: 'Website', icon: 'fad fa-sitemap', alias: '/site/:site_id/website/:sub_dir'},
        {href: {name: 'colours'}, title: 'Design', icon: 'fad fa-palette', alias: '/site/:site_id/design/:sub_dir'},
      ]
    }
  },
  firestore: function () {
    return {
      site: db.collection('site').doc(this.$route.params.site_id)
    }
  },
  computed: {
    trial_days_left() {
      if (this.site && this.site.trial_end) {
        return moment(this.site.trial_end.toDate()).diff(moment(), 'days')
      }

      return undefined
    }
  },
  methods: {
    item_click(e, item) {
      if (item.title === 'View') {
        window.open(`https://${this.site.domain ? this.site.domain : `${this.site.id}.netlify.app`}`, '_blank');
      }
    },
    onToggleCollapse(collapsed) {
      console.log(collapsed)
      this.collapsed = collapsed
    }
  },
  metaInfo() {
    return {
      title: 'site_container'
    };
  },
}
</script>

<style>

.sidebar  {
  padding-left: 250px;
}

.sidebar.collapsed {
  padding-left: 50px;
}

.notice {
  width: 100%;
  padding: 2em;
  color: white;
  background: #051e34;
}

</style>
